import React, {Fragment} from "react";
import SweetAlertBase from "./SweetAlertBase";
import SVG from "react-inlinesvg";
import deleteSVG from "../../../assets/svg/ils/ils-delete.svg";
// import "../../../assets/sass/pages/scouting/delete-confirm-modal.scss";

class SA_ConfirmDelete extends SweetAlertBase {

    config = {
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
    }

    html =  (
        <Fragment>
            <SVG src={deleteSVG}/>
            <h2>Delete Scouting Report?</h2>
        </Fragment>
    );

    type() {
      return 'sm';
    }

    className() {
        return "delete-confirm";
    }

    confirmButtonClasses() {
        return "btn secondary btn-md btn-block";
    }

    cancelButtonClasses() {
        return "btn btn-primary btn-md btn-block";
    }
};

export default SA_ConfirmDelete;